export default __webpack_public_path__ + "static/media/icons8-twitter.54e8f7ac.svg";